module.exports = __webpack_public_path__ + "img/btn-list.b549c7fa.svg";